(function () {
  'use strict';
  if (window.__bbCartInit) return;
  window.__bbCartInit = true;
  /* BB_CART_JS_V2_20261002 — Brick Blaster cart rules, loaded on every page (the cart drawer lives on every page).
     Colors of the nudge come from assets/bb-vars.css.
       1. Gift guard: a Mini Blaster gift line stays only while Shopify prices it at zero (2+ Brick Blasters in the
          cart and the free-Mini discount applied). It is removed otherwise. Nothing is ever added silently.
       2. Nudge: exactly 3 Brick Blasters in the cart -> one line with a button that adds the fourth (free) one.
       3. A cart toggle the shopper switched off stays off for that cart.
       4. Free-shipping bar: the threshold is converted for markets that do not pay in the shop currency.
     No price is set or computed for the cart here; totals always come from Shopify. */

  var BLASTER = 'brick-blaster', MINI = 'mini-blaster', GIFT_PROP = '_bb_gift', STORE_KEY = 'bbCartToggles';
  var NUDGE_TEXT = 'Add 1 more Brick Blaster — it\'s FREE', NUDGE_BTN = '+ ADD';

  function drawer() { return document.querySelector('cart-drawer'); }
  function num(v) { var n = Number(v); return isFinite(n) ? n : 0; }
  function route(name, fallback) { return ((window.routes && window.routes[name]) || fallback); }
  function toggles(scope) { return [].slice.call((scope || document).querySelectorAll('cart-drawer cart-drawer-upsell[data-toggle="true"]')); }

  /* ---------- 3. remembered toggle choice ---------- */
  function cartToken() { try { var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/); return m ? decodeURIComponent(m[1]).split('?')[0] : ''; } catch (e) { return ''; } }
  function readChoice() { try { var o = JSON.parse(window.localStorage.getItem(STORE_KEY) || 'null'); return (o && typeof o === 'object' && Array.isArray(o.off)) ? o : null; } catch (e) { return null; } }
  function offHandles() { var o = readChoice(); if (!o) return []; var t = cartToken(); return (o.token && t && o.token !== t) ? [] : o.off; }
  function storeChoice(handle, off) {
    if (!handle) return;
    try {
      var list = offHandles().filter(function (h) { return h !== handle; });
      if (off) list.push(handle);
      if (list.length) window.localStorage.setItem(STORE_KEY, JSON.stringify({ token: cartToken(), off: list }));
      else window.localStorage.removeItem(STORE_KEY);
    } catch (e) {}
  }
  function applyChoice() {
    var off = offHandles(); if (!off.length) return;
    toggles().forEach(function (u) { if (off.indexOf(u.dataset.handle) >= 0 && u.dataset.selected !== 'false') u.dataset.selected = 'false'; });
  }
  /* runs now: this file is placed before the theme's own script, which reads the toggles when it starts */
  applyChoice();
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('cart-drawer cart-drawer-upsell[data-toggle="true"] .upsell-toggle-btn');
    if (!btn) return;
    var host = btn.closest('cart-drawer-upsell');
    window.setTimeout(function () { storeChoice(host.dataset.handle, host.dataset.selected === 'false'); }, 0);
  }, true);

  /* ---------- drawer rendering through the theme's own contract ---------- */
  function render(data) {
    var cd = drawer();
    if (!cd || !data || !data.sections || !data.sections['cart-drawer'] || typeof cd.renderContents !== 'function') return false;
    cd.renderContents(data, true);
    cd.classList.toggle('is-empty', data.item_count === 0);
    return true;
  }
  function post(url, body) {
    body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart-' + r.status); return r.json(); });
  }
  function afterWrite(data) {
    /* The full cart page also has a hidden drawer; refresh its table after server-side corrections. */
    if (document.querySelector('cart-items')) {
      window.location.reload();
      return;
    }
    if (render(data)) return;
  }

  /* ---------- 1. gift guard ---------- */
  var busy = false, again = false, timer = null;
  function isGift(item) { return String(item.handle || '') === MINI && item.properties && item.properties[GIFT_PROP] != null && String(item.properties[GIFT_PROP]) !== ''; }
  function plan(cart) {
    var blasters = 0, updates = {}, kept = false, upsell = toggles().map(function (u) { return u.dataset.handle; });
    (cart.items || []).forEach(function (item) { if (String(item.handle || '') === BLASTER) blasters += num(item.quantity); });
    (cart.items || []).forEach(function (item) {
      if (!isGift(item) || !item.key) return;
      if (blasters < 2 || kept) { updates[item.key] = 0; return; }          /* below the offer, or a second gift line */
      if (num(item.quantity) > 1) { updates[item.key] = 1; kept = true; return; }  /* one gift per order */
      if (num(item.final_line_price) > 0) { updates[item.key] = 0; return; }       /* Shopify does not make it free: not a gift */
      kept = true;
    });
    var changed = Object.keys(updates).length > 0, othersLeft = false;
    (cart.items || []).forEach(function (item) {
      var gone = Object.prototype.hasOwnProperty.call(updates, item.key) && updates[item.key] === 0;
      if (!gone && upsell.indexOf(String(item.handle || '')) < 0) othersLeft = true;
    });
    return { updates: updates, changed: changed, clear: changed && !othersLeft && (cart.items || []).length > 0 };
  }
  function hasMini() { return !!document.querySelector('.cart-item--product-' + MINI); }
  function guard() {
    /* BB_OFFER_TESTS_20261019: normalization uses exact keys and keeps this guard's add-on-only clear rule. */
    if (window.BrickOfferTests) { window.BrickOfferTests.reconcile().catch(function () {}); return; }
    if (busy) { again = true; return; }
    if (!hasMini()) return;
    busy = true;
    fetch(route('cart_url', '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart-read-' + r.status); return r.json(); })
      .then(function (cart) {
        var p = plan(cart);
        if (!p.changed) return null;
        if (p.clear) return post(route('cart_clear_url', '/cart/clear') + '.js', {}).then(afterWrite);
        return post(route('cart_update_url', '/cart/update') + '.js', { updates: p.updates }).then(afterWrite);
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; schedule(300); } });
  }
  function schedule(delay) { if (timer) window.clearTimeout(timer); timer = window.setTimeout(function () { timer = null; guard(); }, delay || 350); }

  /* ---------- 2. nudge ---------- */
  function blasterLines() { return [].slice.call(document.querySelectorAll('cart-drawer .cart-item--product-' + BLASTER)); }
  function blasterQty() { return blasterLines().reduce(function (q, li) { return q + (parseInt(li.dataset.quantity, 10) || 0); }, 0); }
  function paintNudge() {
    var cd = drawer(); if (!cd) return;
    var items = cd.querySelector('cart-drawer-items'), el = cd.querySelector('[data-bb-nudge]');
    if (!items || (window.BrickOfferTests && window.BrickOfferTests.treatment()) || blasterQty() !== 3) { if (el) el.remove(); return; }
    if (el) return;
    el = document.createElement('div');
    el.className = 'bb-nudge'; el.setAttribute('data-bb-nudge', '');
    var txt = document.createElement('span'); txt.className = 'bb-nudge__txt'; txt.textContent = NUDGE_TEXT;
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'bb-nudge__btn'; btn.setAttribute('data-bb-add-one', ''); btn.textContent = NUDGE_BTN;
    el.appendChild(txt); el.appendChild(btn);
    items.insertAdjacentElement('afterend', el);
  }
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-bb-add-one]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var line = blasterLines()[0]; if (!line) return;
    var items = line.closest('cart-drawer-items'), index = line.dataset.index, qty = (parseInt(line.dataset.quantity, 10) || 0) + 1;
    btn.disabled = true;
    fetch(route('cart_url', '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('cart-read'); return r.json(); }).then(function (cart) {
      var exact = cart.items.find(function (item) { return item.handle === BLASTER; });
      if (!exact || !exact.key) throw new Error('missing-line-key');
      return post(route('cart_change_url', '/cart/change') + '.js', { id: exact.key, quantity: exact.quantity + 1 });
    }).then(function (data) {
      return window.BrickOfferTests ? window.BrickOfferTests.reconcile().then(function () { return window.BrickOfferTests.refresh(); }) : afterWrite(data);
    }).catch(function () { btn.disabled = false; });
  });

  /* ---------- 4. free-shipping bar in markets with another currency ---------- */
  /* Same look as the theme's own money filter: the bar carries one amount (1234.56) formatted by Liquid for this
     market; symbol position and separators are taken from it. */
  function money(cents, sample) {
    var whole = Math.floor(cents / 100), frac = cents % 100;
    var m = String(sample || '').match(/^(\D*)1(\D?)234(?:(\D)56)?(\D*)$/);
    if (m) {
      var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, m[2] || '');
      if (frac !== 0 && m[3]) out += m[3] + (frac < 10 ? '0' : '') + frac;
      return m[1] + out + m[4];
    }
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code, minimumFractionDigits: frac === 0 ? 0 : 2 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + (code ? ' ' + code : ''); }
  }
  /* BB_CART_UPGRADE_20261021: free shipping on every order. snippets/bb-cart-config.liquid switches the
     free-shipping bar off (not rendered); never repaint or re-show it while that switch is off. */
  function cartConfig() {
    try { var el = document.querySelector('script[data-bb-cart-config]'); return el ? (JSON.parse(el.textContent || '{}') || {}) : {}; } catch (e) { return {}; }
  }
  function paintFreeShip() {
    if (cartConfig().freeShippingBar === false) return;
    var rate = window.Shopify && Shopify.currency ? parseFloat(Shopify.currency.rate) : 1;
    if (!isFinite(rate) || rate <= 0 || Math.abs(rate - 1) < 0.000001) return;   /* shop currency: the theme's own text is right */
    var cd = drawer(); if (!cd) return;
    var bar = cd.querySelector('.cart-progress[data-bb-goal]'), items = cd.querySelector('cart-drawer-items');
    if (!bar || !items) return;
    var goal = Math.round(num(bar.getAttribute('data-bb-goal')) * rate), total = num(items.dataset.subtotal);
    if (!goal) return;
    var text = bar.querySelector('.cart-progress__text'), fill = bar.querySelector('.cart-progress__bar__progress');
    var reached = total >= goal, html;
    if (reached) html = bar.getAttribute('data-bb-success') || '';
    else html = (bar.getAttribute('data-bb-progress') || '').replace('[amount]', '<span>' + money(goal - total, bar.getAttribute('data-bb-money')) + '</span>');
    if (text && text.getAttribute('data-bb-painted') !== html) { text.innerHTML = html; text.setAttribute('data-bb-painted', html); }
    if (fill) { var w = (reached ? 100 : Math.max(0, Math.min(100, total * 100 / goal))) + '%'; if (fill.style.width !== w) fill.style.width = w; }
  }

  /* ---------- wiring ---------- */
  function paint() { try { paintNudge(); paintFreeShip(); } catch (e) {} }
  function onChange() { paint(); schedule(300); }
  function style() {
    if (document.getElementById('bb-cart-style')) return;
    var s = document.createElement('style'); s.id = 'bb-cart-style';
    s.textContent = '.bb-nudge{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:10px 0 6px;padding:10px 12px;border-radius:12px;background:var(--bb-accent-soft);border:1px solid var(--bb-line);color:var(--bb-ink);font-size:15px;font-weight:700;line-height:1.25}'
      + '.bb-nudge__btn{flex:0 0 auto;min-height:44px;padding:8px 16px;border:0;border-radius:10px;background:var(--bb-accent);color:var(--bb-accent-label);font-family:inherit;font-size:14px;font-weight:800;letter-spacing:.04em;line-height:1;cursor:pointer}'
      + '.bb-nudge__btn[disabled]{opacity:.6;cursor:default}';
    document.head.appendChild(s);
  }
  function start() {
    style();
    var cd = drawer();
    if (cd && !cd.__bbObserved) {
      cd.__bbObserved = true;
      try { new MutationObserver(onChange).observe(cd, { childList: true, subtree: true }); } catch (e) {}
    }
    onChange();
  }
  ['bb:cart:changed', 'cartQuantityUpdated'].forEach(function (name) { document.addEventListener(name, onChange); });
  window.addEventListener('pageshow', function () { applyChoice(); onChange(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
